module.exports = __webpack_public_path__ + "img/zi_bg.b6f22667.png";